// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#confirm-update {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#confirm-update-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  width: 100%;
}
#confirm-update-header h4 {
  margin: auto;
  color: var(--color-primary);
}

#confirm-update-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  row-gap: 10px;
  height: 100%;
}

a {
  text-decoration: none;
}

#confirm-update-form-container > div, #confirm-update-form > label {
  margin: 20px;
}

#confirm-update-form-container {
  width: max(80%, 500px);
}

#confirm-code-btn {
  margin: 20px 30px;
  width: max(40%, 300px);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/driver-details/confirm-update/confirm-update.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAAI;EACI,YAAA;EACA,2BAAA;AAER;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,sBAAA;AACJ","sourcesContent":["#confirm-update {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n#confirm-update-header {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    background-color: white;\r\n    width: 100%;\r\n    h4 {\r\n        margin: auto;\r\n        color: var(--color-primary);\r\n    }\r\n}\r\n\r\n#confirm-update-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    row-gap: 10px;\r\n    height: 100%;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n#confirm-update-form-container > div, #confirm-update-form > label {\r\n    margin: 20px;\r\n}\r\n\r\n#confirm-update-form-container {\r\n    width: max(80%, 500px);\r\n}\r\n\r\n#confirm-code-btn {\r\n    margin: 20px 30px;\r\n    width: max(40%, 300px);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
